let mountFuncArr = [];//注册的功能
let curFuncObjArr = [];//当前激活状态的功能数组

export  default {
  /**
   * overlap功能注册
   * @param {String} funcId 功能名称
   * @param {Object} funcObj  功能对象
   */
  registerMountFunc(funcId,funcObj){
    let findExit = mountFuncArr.findIndex(item => {return item.funcId === funcId});
    if(findExit > -1){
      mountFuncArr.splice(findExit,1);
    }
    mountFuncArr.push({'funcId':funcId,'funcObj':funcObj});
  },

  /**
   * 重新初始化MountFuncMenu
   */
  resetMountFuncMenu(){
    mountFuncArr = [];
    curFuncObjArr = [];
  },

  /**
   * 返回所有已注册的功能名称
   * @returns {Array}
   */
  getRegisteredNames(){
    let res = [];
    mountFuncArr.forEach(item => {res.push(item.funcId)});
    return res;
  },


  //激活单个功能
  activeFunc(funcId,handleRepeatFun = true,method){
    let curFunc = mountFuncArr.find(item => {//通过功能ID在挂载功能注册中心查找功能实例
      return item.funcId === funcId;
    });
    if(curFunc){
      if(curFunc.funcObj.overlapStatus && handleRepeatFun ){//判断该功能当前状态(激活/卸载)
        curFunc.funcObj.overlapStatus = false;
        curFunc.funcObj.inActive();
        this.deleteFunc(curFunc);
        if(method){
          method();
        }
        return
      }
      if(curFunc.funcObj.overlapStatus && !handleRepeatFun){/*如果handleRepeatFun为false则重复点击该功能不执行active也不执行inActive,并加入激活数组中*/
        let index = curFuncObjArr.findIndex(item => {return item.funcId === curFunc.funcId});
        if(index < 0){
          curFunc.funcObj.overlapStatus = true;//设置当前挂载功能状态为ture
          curFuncObjArr.push(curFunc);//将该功能存到激活功能数组中
        }
        curFunc.funcObj.active();
        return;
      }
      curFunc.funcObj.active();
      curFunc.funcObj.overlapStatus = true;//设置当前挂载功能状态为ture
      curFuncObjArr.push(curFunc);//将该功能存到激活功能数组中
      if(method){
        method();
      }
    }
  },




  /**
   * 通过功能ID查找功能实例
   * @param funcId 功能ID
   * @returns {*}
   */
  findFuncObjById(funcId){
    let obj = mountFuncArr.find(item => {//通过功能ID在挂载功能注册中心查找功能实例
      return item.funcId === funcId;
    });
    return obj;
  },


  /**
   * 通过功能ID卸载当功能
   * @param funcId 功能ID
   */
  inActiveFuncById(funcId,params){
    let curFunc = mountFuncArr.find(item => {
      return item.funcId === funcId;
    });
    if(curFunc){
      curFunc.funcObj.overlapStatus = false;
      curFunc.funcObj.inActive(params);
      this.deleteFunc(curFunc);
    }
  },

  /*将卸载的功能从当前激活功能数组中移除*/
  deleteFunc(func){
    let index = curFuncObjArr.findIndex(item => {return func.funcId === item.funcId });
    if(index > -1){
      curFuncObjArr.splice(index,1);
    }
  },


  /**
   *通过Id执行某功能的clear函数
   */
  clearById(funcId){
    let res = this.findFuncObjById(funcId);
    if(res){
      res.funcObj.clear();
    }
  },

  /**
   * 执行所有当前激活状态功能的clear函数
   */
  clearAll(){
    for(let item of curFuncObjArr){
      try{
        item.funcObj.clear();
      }catch (err){
        console.error(`${item.funcId}功能clear函数执行异常`);
      }
    }
  },

  /**
   * 卸载所有挂载的overlap功能
   */
  inActiveAll(){
    for(let item of curFuncObjArr){
      try{
        item.funcObj.overlapStatus = false;
        item.funcObj.inActive();
      }catch (err){
        console.error(`${item.funcId}功能inactive函数执行异常`);
      }
    }
    curFuncObjArr = [];
  },

}



// WEBPACK FOOTER //
// ./src/common/mountFuncMenu.js